import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Campaign,
  Character,
  CharacterCustomItem,
} from "@dndModels";

import API from "@utilities/smart_api";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';

import ButtonBox from "@components/input/buttons/ButtonBox";
import StringBox from "@components/input/strings/StringBox";

interface Props {
  char: Character | Campaign;
  char_item: CharacterCustomItem;
  // onChange: (repopulate: boolean, close: boolean) => void;
  onRemove: () => void;
}

const api = API.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterCustomItemControls({
  char,
  char_item,
  // onChange,
  onRemove
}: Props) {
  const [ping, setPing] = useState(false);

  const enabled = api.user && (char.owner_id === api.user._id || (char.owner_id === api.user_id || (char instanceof Character && char.campaign && char.campaign.owner_id === api.user._id)));
  
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox 
          name="Name"
          value={char_item.name}
          onBlur={(changed: string) => {
            char_item.name = changed;
            // onChange(false, false);
            char.changed();
            char.subscription_holder.itemsChanged();
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox 
          name="Notes"
          value={char_item._notes}
          onBlur={(changed: string) => {
            char_item._notes = changed;
            // onChange(false, false);
            char.changed();
            char.subscription_holder.itemsChanged();
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <StringBox 
          name="Cost (in gp)"
          value={`${char_item.cost}`}
          type="number"
          onBlur={(changed: string) => {
            char_item.cost = +changed;
            // onChange(false, false);
            char.changed();
            char.subscription_holder.itemsChanged();
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <StringBox 
          name="Weight (in lbs)"
          value={`${char_item._weight}`}
          onBlur={(changed: string) => {
            char_item._weight = +changed;
            // onChange(false, false);
            char.changed();
            char.subscription_holder.itemsChanged();
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox 
          name="Description"
          value={char_item.description}
          multiline
          onBlur={(changed: string) => {
            char_item.description = changed;
            // onChange(false, false);
            char.changed();
            char.subscription_holder.itemsChanged();
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox 
          name="Quantity"
          value={char_item.count ? `${char_item.count}` : "1"}
          type="number"
          onBlur={(changed: string) => {
            char_item.count = +changed;
            // onChange(false, false);
            char.changed();
            char.subscription_holder.itemsChanged();
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <ButtonBox 
          name="Remove"
          // width={100}
          // height={20}
          style={{                  
            fontSize: "8px",
            lineHeight: "2.7"
          }}
          disabled={ !enabled }
          onClick={() => {
            connect_util.removeItem(char, char_item);
            // onChange(true, true);
            onRemove();
            setPing(!ping);
          }}
        />
      </Grid>
    </Grid>
  );
}
